// import React, { useEffect, useRef, useState } from "react";
// import "./Main_Chart_Section.css";
// import { Offcanvas } from "react-bootstrap";

// import io from "socket.io-client";

// import Buy_sell_Btns from "../right_end_toolbar/buy_sell_btns/Buy_sell_Btns";
// import Right_End_Toolbar from "../right_end_toolbar/Right_End_Toolbar";
// import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
// import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
// import { getAllCompanyMarketPrice } from "../../../../utils/apis/graph/graph";
// import Portfolio from "./portfolio/Portfolio";
// import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import {
//   createChart,
//   CrosshairMode,
//   CandlestickSeries, // <-- important for v5
// } from "lightweight-charts";

// import StockAdvancedChart from "./StockAdvancedChart";

// const Main_Chart_Section = ({
//   companyId,
//   setLatestAmount,
//   latestAmount,
//   price,
//   setPrice,
//   companyName,
//   setLatestData,
//   latestData,
//   priceHistory,
//   setPriceHistory,
//   latestCloses,
//   setLatestCloses,
//   getPriceHistory,
//   latestBaseCloses,
//   setLatestBaseCloses,

//   getGraphData,
//   onHide,
//   belowGraphData,
//   setActiveBtn,
//   activeBtn,
//   handlePageChange,
//   showClsoeModal,
//   showDeleteModal,
//   showClsoeModalClose,
//   showDeleteModalClose,
//   setCloseTradeId,
//   closeTradeId,
// }) => {
//   const [showmarketfOffCanva, setShowmarketfOffCanva] = useState(false);
//   const fullDataRef = useRef([]);
//   const [timeframe, setTimeframe] = useState("1M");
//   const [showModal, setShowModal] = useState(false);

//   const [hoveredCandle, setHoveredCandle] = useState(null);

//   const [showPortfoliofOffCanva, setShowPortfoliofOffCanva] = useState(false);

//   const chartRef = useRef(null);
//   const valueSeriesRef = useRef(null);
//   const sbSeriesRef = useRef(null);

//   const filterDataByTimeframe = (data, timeframe) => {
//     if (!data || data.length === 0) return [];

//     const now = new Date();
//     let cutoff = new Date();

//     switch (timeframe) {
//       case "1M":
//         cutoff.setMinutes(now.getMinutes() - 60);
//         break;
//       case "2M":
//         cutoff.setMinutes(now.getMinutes() - 60);
//         break;
//       case "5M":
//         cutoff.setMinutes(now.getMinutes() - 60);
//         break;
//       case "15M":
//         cutoff.setMinutes(now.getMinutes() - 15);
//         break;
//       case "30M":
//         cutoff.setMinutes(now.getMinutes() - 30);
//         break;
//       case "1H":
//         cutoff.setHours(now.getHours() - 1);
//         break;
//       case "2H":
//         cutoff.setHours(now.getHours() - 2);
//         break;
//       case "3H":
//         cutoff.setHours(now.getHours() - 3);
//         break;
//       case "4H":
//         cutoff.setHours(now.getHours() - 4);
//         break;

//       case "1Y":
//         cutoff.setFullYear(now.getFullYear() - 1);
//         cutoff.setHours(12, 0, 0, 0);
//         break;
//       case "ALL":
//       default:
//         return data;
//     }

//     return data.filter((item) => {
//       const date = new Date(+item.Date); // convert timestamp to Date
//       return date >= cutoff;
//     });
//   };

//   const [candleData, setCandleData] = useState([]);

//   const aggregateData = (data, intervalMinutes) => {
//     const grouped = {};

//     data.forEach((d) => {
//       // Calculate which bucket this data belongs to
//       const bucketTime =
//         Math.floor(+d.Date / (1000 * 60 * intervalMinutes)) *
//         (60 * intervalMinutes);

//       if (!grouped[bucketTime]) {
//         grouped[bucketTime] = {
//           time: bucketTime, // seconds for chart
//           open: +d.Open,
//           high: +d.High,
//           low: +d.Low,
//           close: +d.Close,
//         };
//       } else {
//         grouped[bucketTime].high = Math.max(grouped[bucketTime].high, +d.High);
//         grouped[bucketTime].low = Math.min(grouped[bucketTime].low, +d.Low);
//         grouped[bucketTime].close = +d.Close; // last one overrides
//       }
//     });

//     return Object.values(grouped).sort((a, b) => a.time - b.time);
//   };

//   const timeframeMap = {
//     "1M": 1,
//     "2M": 2,
//     "5M": 5,
//     "1H": 60,
//     "2H": 120,
//     "3H": 180,
//     "4H": 240,
//     "1Y": 525600, // special handling (probably daily/weekly candles)
//     ALL: null, // special handling
//   };

//   // useEffect(() => {
//   //   // Socket.io connection for live data
//   //   const socket = io("http://127.0.0.1:1515");
//   //   // const socket = io("https://stockwave-node.profcyma.org:1517");
//   //   // const socket = io("http://192.168.16.38:1515");

//   //   priceHistory.forEach((item) => {
//   //     socket.on(item?.id, (data) => {
//   //       if (!data) return;

//   //       if (item.id === companyId) {
//   //         fullDataRef.current = data;

//   //         const filteredData = data;

//   //         const intervalMinutes = timeframeMap[timeframe];

//   //         let newcandleData;
//   //         if (intervalMinutes) {
//   //           // aggregate to selected interval
//   //           newcandleData = aggregateData(filteredData, intervalMinutes);
//   //         } else {
//   //           // no aggregation, just map as-is for "ALL" or "1Y"
//   //           // newcandleData = filteredData.map((d) => ({
//   //           //   time: Math.floor(+d.Date / 1000),
//   //           //   open: +d.Open,
//   //           //   high: +d.High,
//   //           //   low: +d.Low,
//   //           //   close: +d.Close,
//   //           // }));

//   //           newcandleData = Array.from(
//   //             new Map(
//   //               filteredData.map((d) => [
//   //                 Math.floor(new Date(+d.Date) / 1000), // key = time
//   //                 {
//   //                   time: Math.floor(new Date(+d.Date) / 1000),
//   //                   open: +d.Open,
//   //                   high: +d.High,
//   //                   low: +d.Low,
//   //                   close: +d.Close,
//   //                 },
//   //               ])
//   //             ).values() // removes duplicates by time
//   //           ).sort((a, b) => a.time - b.time);
//   //         }

//   //         setCandleData(newcandleData);

//   //         if (filteredData.length > 0) {
//   //           const lastCandle = filteredData[filteredData.length - 1];

//   //           console.log(lastCandle, "lastCandlelastCandle");

//   //           setLatestAmount(lastCandle.Close);

//   //           // Set companyId and latest amount together
//   //           setLatestData((prev) => ({
//   //             ...prev,
//   //             [companyId]: lastCandle.Close,
//   //           }));
//   //         }
//   //       }
//   //       const lastCandle = data[data.length - 1];

//   //       setLatestCloses((prev) => ({
//   //         ...prev,
//   //         [item.id]: lastCandle.Close,
//   //       }));

//   //       const lastBaseCandle = data[data.length - 2];

//   //       setLatestBaseCloses((prev) => ({
//   //         ...prev,
//   //         [item.id]: lastBaseCandle.Close,
//   //       }));
//   //     });
//   //   });

//   //   return () => {
//   //     socket.disconnect();
//   //   };
//   // }, [companyId, timeframe, setLatestAmount]);

//   // When timeframe changes, update chart data with filtered data
//   // useEffect(() => {
//   //   const filteredData = filterDataByTimeframe(fullDataRef.current, timeframe);
//   //   if (valueSeriesRef.current && sbSeriesRef.current) {
//   //     valueSeriesRef.current.data.setAll(filteredData);
//   //     sbSeriesRef.current.data.setAll(filteredData);
//   //   }
//   // }, [timeframe]);

//   const socketRef = useRef(null);

//   // Stable socket connection
//   useEffect(() => {
//     const socket = io("http://127.0.0.1:1515", {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 2000,
//     });

//     socketRef.current = socket;

//     socket.on("connect", () => {
//       console.log("🟢 Socket connected:", socket.id);
//     });

//     socket.on("disconnect", () => {
//       console.log("🔴 Socket disconnected");
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, []); // connect only once

//   // Listen to priceHistory updates
//   useEffect(() => {
//     const socket = socketRef.current;
//     if (!socket) return;
//     if (!priceHistory || priceHistory.length === 0) return;

//     const listeners = [];

//     priceHistory.forEach((item) => {
//       const handler = (data) => {
//         if (!data || data.length === 0) return;

//         const filteredData = data;
//         if (item.id === companyId) {
//           fullDataRef.current = filteredData;

//           requestIdleCallback(() => {
//             let newCandleData;
//             const intervalMinutes = timeframeMap[timeframe];

//             if (intervalMinutes) {
//               newCandleData = aggregateData(filteredData, intervalMinutes);
//             } else {
//               // Efficient unique mapping
//               const uniqueMap = new Map();
//               filteredData.forEach((d) => {
//                 const t = Math.floor(new Date(+d.Date) / 1000);
//                 uniqueMap.set(t, {
//                   time: t,
//                   open: +d.Open,
//                   high: +d.High,
//                   low: +d.Low,
//                   close: +d.Close,
//                 });
//               });
//               newCandleData = Array.from(uniqueMap.values()).sort(
//                 (a, b) => a.time - b.time
//               );
//             }

//             setCandleData(newCandleData);

//             const lastCandle = filteredData.at(-1);
//             if (lastCandle) {
//               setLatestAmount(lastCandle.Close);
//               setLatestData((prev) => ({
//                 ...prev,
//                 [companyId]: lastCandle.Close,
//               }));
//             }
//           });
//         }

//         // Update latest closes for all priceHistory items
//         const lastCandle = filteredData.at(-1);
//         const lastBaseCandle = filteredData.at(-2);

//         if (lastCandle && lastBaseCandle) {
//           setLatestCloses((prev) => ({ ...prev, [item.id]: lastCandle.Close }));
//           setLatestBaseCloses((prev) => ({
//             ...prev,
//             [item.id]: lastBaseCandle.Close,
//           }));
//         }
//       };

//       socket.on(item.id, handler);
//       listeners.push({ id: item.id, handler });
//     });

//     return () => {
//       listeners.forEach(({ id, handler }) => socket.off(id, handler));
//     };
//   }, [companyId, timeframe, priceHistory, timeframeMap]);
//   return (
//     <>
//       <section className="Main_Chart_Section">
//         {hoveredCandle && (
//           <div
//             style={{ color: "#fff", marginBottom: "10px", fontSize: "14px" }}
//           >
//             <strong>{hoveredCandle.date.toLocaleString()}</strong>
//             <br />
//             Open: {hoveredCandle.open} | High: {hoveredCandle.high} | Low:{" "}
//             {hoveredCandle.low} | Close: {hoveredCandle.close}
//           </div>
//         )}

//         <div
//           className="timeframe_buttons_holder"
//           style={{ marginBottom: "10px", textAlign: "right" }}
//         >
//           <p className="company_name">{companyName}</p>

//           <div>
//             {["1M", "2M", "5M", "1H", "2H", "3H", "4H", "1Y"].map((tf) => (
//               <button
//                 key={tf}
//                 onClick={() => setTimeframe(tf)}
//                 className="timeframe_buttons"
//                 style={{
//                   backgroundColor: timeframe === tf ? "#007bff" : "#333",
//                 }}
//               >
//                 {tf}
//               </button>
//             ))}
//           </div>
//         </div>

//         {priceHistory.map(
//           (value) =>
//             value.id === companyId && (
//               <div className="candle_chart_div">
//                 {/* <StockAdvancedChart
//                   companyId={value.id}
//                   timeframe={timeframe}
//                   filterDataByTimeframe={filterDataByTimeframe}
//                   fullDataRef={fullDataRef}
//                   setLatestAmount={setLatestAmount}
//                   candleData={candleData}
//                 /> */}
//                 {candleData.length > 0 && (
//                   <StockAdvancedChart
//                     companyId={value.id}
//                     timeframe={timeframe}
//                     filterDataByTimeframe={filterDataByTimeframe}
//                     fullDataRef={fullDataRef}
//                     setLatestAmount={setLatestAmount}
//                     candleData={candleData}
//                   />
//                 )}

//                 {/* <div id="chartdiv" style={{ width: "100%" }} ref={chartRef}></div> */}
//               </div>
//             )
//         )}

//         {/* <div className="mobile_portfolio_div">
//           <Portfolio
//             getGraphData={getGraphData}
//             onHide={onHide}
//             companyId={companyId}
//             belowGraphData={belowGraphData}
//             latestAmount={latestAmount}
//             setActiveBtn={setActiveBtn}
//             activeBtn={activeBtn}
//             handlePageChange={handlePageChange}
//             showClsoeModal={showClsoeModal}
//             showDeleteModal={showDeleteModal}
//             showClsoeModalClose={showClsoeModalClose}
//             showDeleteModalClose={showDeleteModalClose}
//             setCloseTradeId={setCloseTradeId}
//             closeTradeId={closeTradeId}
//           />
//         </div> */}

//         <div className="profit_div">
//           <p
//             // className="status_text profit_text"
//             className="status_text loss_text"
//             onClick={() => {
//               setShowPortfoliofOffCanva(true);
//             }}
//           >
//             portfolio
//             <FontAwesomeIcon icon={faAngleUp} className="icon" />
//           </p>
//         </div>

//         <div className="byu_sell_div">
//           <Buy_sell_Btns
//             latestAmount={latestAmount}
//             setPrice={setPrice}
//             price={price}
//             sellOnClick={() => setShowmarketfOffCanva(true)}
//             BuyOnClick={() => setShowmarketfOffCanva(true)}
//           />
//         </div>

//         <Offcanvas
//           className="col_4_offcanvas col_2_offcanvas"
//           show={showmarketfOffCanva}
//           onHide={() => setShowmarketfOffCanva(false)}
//           placement="end"
//         >
//           <Offcanvas.Body>
//             <Right_End_Toolbar
//               setPrice={setPrice}
//               price={price}
//               latestAmount={latestAmount}
//               companyId={companyId}
//               companyName={companyName}
//               onClose={() => setShowmarketfOffCanva(false)}
//               openSuccess={() => {
//                 setShowModal(true);
//               }}
//               openSuccessClose={() => {
//                 setShowModal(false);
//               }}
//               isMobile={true}
//             />
//           </Offcanvas.Body>
//         </Offcanvas>

//         <Offcanvas
//           className="col_4_offcanvas portfolio_mobile_offcanvas"
//           show={showPortfoliofOffCanva}
//           onHide={() => setShowPortfoliofOffCanva(false)}
//           placement="bottom"
//         >
//           <Offcanvas.Header>
//             <FontAwesomeIcon
//               icon={faAngleDown}
//               className="down_icon"
//               onClick={() => setShowPortfoliofOffCanva(false)}
//             />
//           </Offcanvas.Header>
//           <Offcanvas.Body>
//             <div className="main_div">
//               <Portfolio
//                 getGraphData={getGraphData}
//                 onHide={onHide}
//                 companyId={companyId}
//                 belowGraphData={belowGraphData}
//                 latestAmount={latestAmount}
//                 setActiveBtn={setActiveBtn}
//                 activeBtn={activeBtn}
//                 handlePageChange={handlePageChange}
//                 showClsoeModal={showClsoeModal}
//                 showDeleteModal={showDeleteModal}
//                 showClsoeModalClose={showClsoeModalClose}
//                 showDeleteModalClose={showDeleteModalClose}
//                 setCloseTradeId={setCloseTradeId}
//                 closeTradeId={closeTradeId}
//               />
//             </div>
//           </Offcanvas.Body>
//         </Offcanvas>

//         <Successfull_Modal
//           message={`Trade Successful! `}
//           show={showModal}
//           onHide={() => {
//             setShowModal(false);
//           }}
//           lottie={<Deposit_Lottie />}
//         />
//       </section>
//     </>
//   );
// };

// export default Main_Chart_Section;

// ----------------------------------------------------------------------------------------------------------
// import React, {
//   useEffect,
//   useRef,
//   useState,
//   useMemo,
//   useCallback,
//   useContext,
// } from "react";
// import "./Main_Chart_Section.css";
// import { Offcanvas } from "react-bootstrap";
// import io from "socket.io-client";
// import Buy_sell_Btns from "../right_end_toolbar/buy_sell_btns/Buy_sell_Btns";
// import Right_End_Toolbar from "../right_end_toolbar/Right_End_Toolbar";
// import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
// import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
// import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import StockAdvancedChart from "./StockAdvancedChart";
// import Portfolio from "./portfolio/Portfolio";
// import { Context } from "../../../../utils/context";

// const debounce = (func, delay) => {
//   let timeoutId;
//   return (...args) => {
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => func(...args), delay);
//   };
// };

// const Main_Chart_Section = ({
//   companyId,
//   setLatestAmount,
//   latestAmount,
//   price,
//   setPrice,
//   companyName,
//   setLatestData,
//   latestData,
//   priceHistory,
//   setPriceHistory,
//   latestCloses,
//   setLatestCloses,
//   latestBaseCloses,
//   setLatestBaseCloses,
//   getGraphData,
//   onHide,
//   belowGraphData,
//   setActiveBtn,
//   activeBtn,
//   handlePageChange,
//   showClsoeModal,
//   showDeleteModal,
//   showClsoeModalClose,
//   showDeleteModalClose,
//   setCloseTradeId,
//   closeTradeId,
// }) => {
//   const { SOCKET } = useContext(Context);
//   const [showmarketfOffCanva, setShowmarketfOffCanva] = useState(false);
//   const [showPortfoliofOffCanva, setShowPortfoliofOffCanva] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [hoveredCandle, setHoveredCandle] = useState(null);
//   const [timeframe, setTimeframe] = useState("1M");
//   const [candleData, setCandleData] = useState([]);
//   const fullDataRef = useRef([]);
//   const socketRef = useRef(null);
//   const chartRef = useRef(null);

//   const timeframeMap = useMemo(
//     () => ({
//       "1M": 1,
//       "2M": 2,
//       "5M": 5,
//       "15M": 15,
//       "30M": 30,
//       "1H": 60,
//       "2H": 120,
//       "3H": 180,
//       "4H": 240,
//       "1Y": 525600,
//       ALL: null,
//     }),
//     []
//   );

//   const filterDataByTimeframe = useCallback((data, tf) => {
//     if (!data || data.length === 0) return [];
//     const now = new Date();
//     let cutoff = new Date();
//     switch (tf) {
//       case "1M":
//         cutoff.setMinutes(now.getMinutes() - 60);
//         break;
//       case "2M":
//         cutoff.setMinutes(now.getMinutes() - 120);
//         break;
//       case "5M":
//         cutoff.setMinutes(now.getMinutes() - 300);
//         break;
//       case "15M":
//         cutoff.setMinutes(now.getMinutes() - 900);
//         break;
//       case "30M":
//         cutoff.setMinutes(now.getMinutes() - 1800);
//         break;
//       case "1H":
//         cutoff.setHours(now.getHours() - 1);
//         break;
//       case "2H":
//         cutoff.setHours(now.getHours() - 2);
//         break;
//       case "3H":
//         cutoff.setHours(now.getHours() - 3);
//         break;
//       case "4H":
//         cutoff.setHours(now.getHours() - 4);
//         break;
//       case "1Y":
//         cutoff.setFullYear(now.getFullYear() - 1);
//         break;
//       case "ALL":
//       default:
//         return data;
//     }
//     return data.filter((item) => new Date(+item.Date) >= cutoff);
//   }, []);

//   const aggregateData = useCallback((data, intervalMinutes) => {
//     const grouped = {};
//     data.forEach((d) => {
//       const bucketTime =
//         Math.floor(+d.Date / (1000 * 60 * intervalMinutes)) *
//         (60 * intervalMinutes);
//       if (!grouped[bucketTime]) {
//         grouped[bucketTime] = {
//           time: bucketTime,
//           open: +d.Open,
//           high: +d.High,
//           low: +d.Low,
//           close: +d.Close,
//         };
//       } else {
//         grouped[bucketTime].high = Math.max(grouped[bucketTime].high, +d.High);
//         grouped[bucketTime].low = Math.min(grouped[bucketTime].low, +d.Low);
//         grouped[bucketTime].close = +d.Close;
//       }
//     });
//     return Object.values(grouped).sort((a, b) => a.time - b.time);
//   }, []);

//   const processedCandleData = useMemo(() => {
//     if (!fullDataRef.current || fullDataRef.current.length === 0) return [];
//     const filteredData = filterDataByTimeframe(fullDataRef.current, timeframe);
//     const intervalMinutes = timeframeMap[timeframe];
//     if (intervalMinutes) {
//       return aggregateData(filteredData, intervalMinutes);
//     } else {
//       const uniqueMap = new Map();
//       filteredData.forEach((d) => {
//         const t = Math.floor(new Date(+d.Date) / 1000);
//         uniqueMap.set(t, {
//           time: t,
//           open: +d.Open,
//           high: +d.High,
//           low: +d.Low,
//           close: +d.Close,
//         });
//       });
//       return Array.from(uniqueMap.values()).sort((a, b) => a.time - b.time);
//     }
//   }, [
//     fullDataRef.current,
//     timeframe,
//     filterDataByTimeframe,
//     aggregateData,
//     timeframeMap,
//   ]);

//   useEffect(() => {
//     setCandleData(processedCandleData);
//   }, [processedCandleData]);

//   const handleTimeframeChange = useCallback(
//     debounce((tf) => {
//       setTimeframe(tf);
//     }, 300),
//     []
//   );

//   useEffect(() => {
//     const socket = io(SOCKET, {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 2000,
//     });
//     socketRef.current = socket;
//     socket.on("connect", () => console.log("Socket connected:", socket.id));
//     socket.on("disconnect", () => console.log("Socket disconnected"));
//     return () => socket.disconnect();
//   }, []);

//   useEffect(() => {
//     const socket = socketRef.current;
//     if (!socket || !priceHistory || priceHistory.length === 0) return;

//     const listeners = priceHistory.map((item) => {
//       const handler = (data) => {
//         if (!data || data.length === 0) return;
//         if (item.id === companyId) {
//           fullDataRef.current = data;
//           requestIdleCallback(() => {
//             const filteredData = data;
//             const lastCandle = filteredData.at(-1);
//             if (lastCandle) {
//               setLatestAmount(lastCandle.Close);
//               setLatestData((prev) => ({
//                 ...prev,
//                 [companyId]: lastCandle.Close,
//               }));
//             }
//           });
//         }
//         const lastCandle = data.at(-1);
//         const lastBaseCandle = data.at(-2);
//         if (lastCandle && lastBaseCandle) {
//           setLatestCloses((prev) => ({ ...prev, [item.id]: lastCandle.Close }));
//           setLatestBaseCloses((prev) => ({
//             ...prev,
//             [item.id]: lastBaseCandle.Close,
//           }));
//         }
//       };
//       socket.on(item.id, handler);
//       return { id: item.id, handler };
//     });

//     return () =>
//       listeners.forEach(({ id, handler }) => socket.off(id, handler));
//   }, [
//     companyId,
//     priceHistory,
//     setLatestAmount,
//     setLatestData,
//     setLatestCloses,
//     setLatestBaseCloses,
//   ]);

//   return (
//     <>
//       <section className="Main_Chart_Section">
//         {hoveredCandle && (
//           <div
//             style={{ color: "#fff", marginBottom: "10px", fontSize: "14px" }}
//           >
//             <strong>{hoveredCandle.date?.toLocaleString()}</strong>
//             <br />
//             Open: {hoveredCandle.open} | High: {hoveredCandle.high} | Low:{" "}
//             {hoveredCandle.low} | Close: {hoveredCandle.close}
//           </div>
//         )}
//         <div
//           className="timeframe_buttons_holder"
//           style={{ marginBottom: "10px", textAlign: "right" }}
//         >
//           <p className="company_name">{companyName}</p>
//           <div>
//             {["1M", "2M", "5M", "15M", "30M", "1H", "2H", "3H", "4H", "1Y"].map(
//               (tf) => (
//                 <button
//                   key={tf}
//                   onClick={() => handleTimeframeChange(tf)}
//                   className="timeframe_buttons"
//                   style={{
//                     backgroundColor: timeframe === tf ? "#007bff" : "#333",
//                   }}
//                 >
//                   {tf}
//                 </button>
//               )
//             )}
//           </div>
//         </div>
//         {priceHistory.map(
//           (value) =>
//             value.id === companyId && (
//               <div className="candle_chart_div" key={value.id}>
//                 {candleData.length > 0 && (
//                   <StockAdvancedChart
//                     companyId={value.id}
//                     timeframe={timeframe}
//                     candleData={candleData}
//                     setLatestAmount={setLatestAmount}
//                   />
//                 )}
//               </div>
//             )
//         )}
//         <div className="profit_div">
//           <p
//             className="status_text loss_text"
//             onClick={() => setShowPortfoliofOffCanva(true)}
//           >
//             portfolio
//             <FontAwesomeIcon icon={faAngleUp} className="icon" />
//           </p>
//         </div>
//         <div className="byu_sell_div">
//           <Buy_sell_Btns
//             latestAmount={latestAmount}
//             setPrice={setPrice}
//             price={price}
//             sellOnClick={() => setShowmarketfOffCanva(true)}
//             BuyOnClick={() => setShowmarketfOffCanva(true)}
//           />
//         </div>
//         <Offcanvas
//           className="col_4_offcanvas col_2_offcanvas"
//           show={showmarketfOffCanva}
//           onHide={() => setShowmarketfOffCanva(false)}
//           placement="end"
//         >
//           <Offcanvas.Body>
//             <Right_End_Toolbar
//               setPrice={setPrice}
//               price={price}
//               latestAmount={latestAmount}
//               companyId={companyId}
//               companyName={companyName}
//               onClose={() => setShowmarketfOffCanva(false)}
//               openSuccess={() => setShowModal(true)}
//               openSuccessClose={() => setShowModal(false)}
//               isMobile={true}
//             />
//           </Offcanvas.Body>
//         </Offcanvas>
//         <Offcanvas
//           className="col_4_offcanvas portfolio_mobile_offcanvas"
//           show={showPortfoliofOffCanva}
//           onHide={() => setShowPortfoliofOffCanva(false)}
//           placement="bottom"
//         >
//           <Offcanvas.Header>
//             <FontAwesomeIcon
//               icon={faAngleDown}
//               className="down_icon"
//               onClick={() => setShowPortfoliofOffCanva(false)}
//             />
//           </Offcanvas.Header>
//           <Offcanvas.Body>
//             <div className="main_div">
//               <Portfolio
//                 getGraphData={getGraphData}
//                 onHide={onHide}
//                 companyId={companyId}
//                 belowGraphData={belowGraphData}
//                 latestAmount={latestAmount}
//                 setActiveBtn={setActiveBtn}
//                 activeBtn={activeBtn}
//                 handlePageChange={handlePageChange}
//                 showClsoeModal={showClsoeModal}
//                 showDeleteModal={showDeleteModal}
//                 showClsoeModalClose={showClsoeModalClose}
//                 showDeleteModalClose={showDeleteModalClose}
//                 setCloseTradeId={setCloseTradeId}
//                 closeTradeId={closeTradeId}
//               />
//             </div>
//           </Offcanvas.Body>
//         </Offcanvas>
//         <Successfull_Modal
//           message="Trade Successful!"
//           show={showModal}
//           onHide={() => setShowModal(false)}
//           lottie={<Deposit_Lottie />}
//         />
//       </section>
//     </>
//   );
// };

// export default Main_Chart_Section;
// // ----------------------------------------------------------------------------------------------------------
// import React, {
//   useEffect,
//   useRef,
//   useState,
//   useMemo,
//   useCallback,
//   useContext,
//   Suspense,
// } from "react";
// import "./Main_Chart_Section.css";
// import { Offcanvas } from "react-bootstrap";
// import io from "socket.io-client";
// import Buy_sell_Btns from "../right_end_toolbar/buy_sell_btns/Buy_sell_Btns";
// import Right_End_Toolbar from "../right_end_toolbar/Right_End_Toolbar";
// import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
// import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
// import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Portfolio from "./portfolio/Portfolio";
// import { Context } from "../../../../utils/context";

// const debounce = (func, delay) => {
//   let timeoutId;
//   return (...args) => {
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => func(...args), delay);
//   };
// };

// const StockAdvancedChart = React.lazy(() => import("./StockAdvancedChart"));

// const Main_Chart_Section = ({
//   companyId,
//   setLatestAmount,
//   latestAmount,
//   price,
//   setPrice,
//   companyName,
//   setLatestData,
//   latestData,
//   priceHistory,
//   setPriceHistory,
//   latestCloses,
//   setLatestCloses,
//   latestBaseCloses,
//   setLatestBaseCloses,
//   getGraphData,
//   onHide,
//   belowGraphData,
//   setActiveBtn,
//   activeBtn,
//   handlePageChange,
//   showClsoeModal,
//   showDeleteModal,
//   showClsoeModalClose,
//   showDeleteModalClose,
//   setCloseTradeId,
//   closeTradeId,
// }) => {
//   const { SOCKET } = useContext(Context);
//   const [showmarketfOffCanva, setShowmarketfOffCanva] = useState(false);
//   const [showPortfoliofOffCanva, setShowPortfoliofOffCanva] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [hoveredCandle, setHoveredCandle] = useState(null);
//   const [timeframe, setTimeframe] = useState("1M");
//   const [candleData, setCandleData] = useState([]);
//   const fullDataRef = useRef([]);
//   const socketRef = useRef(null);

//   const timeframeMap = useMemo(
//     () => ({
//       "1M": 1,
//       "2M": 2,
//       "5M": 5,
//       "15M": 15,
//       "30M": 30,
//       "1H": 60,
//       "2H": 120,
//       "3H": 180,
//       "4H": 240,
//       "1Y": 525600,
//       ALL: null,
//     }),
//     []
//   );

//   const filterDataByTimeframe = useCallback((data, tf) => {
//     if (!data || data.length === 0) return [];
//     const now = new Date();
//     let cutoff = new Date();
//     switch (tf) {
//       case "1M":
//         cutoff.setMinutes(now.getMinutes() - 60);
//         break;
//       case "2M":
//         cutoff.setMinutes(now.getMinutes() - 120);
//         break;
//       case "5M":
//         cutoff.setMinutes(now.getMinutes() - 300);
//         break;
//       case "15M":
//         cutoff.setMinutes(now.getMinutes() - 900);
//         break;
//       case "30M":
//         cutoff.setMinutes(now.getMinutes() - 1800);
//         break;
//       case "1H":
//         cutoff.setHours(now.getHours() - 1);
//         break;
//       case "2H":
//         cutoff.setHours(now.getHours() - 2);
//         break;
//       case "3H":
//         cutoff.setHours(now.getHours() - 3);
//         break;
//       case "4H":
//         cutoff.setHours(now.getHours() - 4);
//         break;
//       case "1Y":
//         cutoff.setFullYear(now.getFullYear() - 1);
//         break;
//       case "ALL":
//       default:
//         return data;
//     }
//     return data;
//     // return data.filter((item) => new Date(+item.Date) >= cutoff);
//   }, []);

//   const aggregateData = useCallback((data, intervalMinutes) => {
//     const grouped = {};
//     data.forEach((d) => {
//       const bucketTime =
//         Math.floor(+d.Date / (1000 * 60 * intervalMinutes)) *
//         (60 * intervalMinutes);
//       if (!grouped[bucketTime]) {
//         grouped[bucketTime] = {
//           time: bucketTime,
//           open: +d.Open,
//           high: +d.High,
//           low: +d.Low,
//           close: +d.Close,
//         };
//       } else {
//         grouped[bucketTime].high = Math.max(grouped[bucketTime].high, +d.High);
//         grouped[bucketTime].low = Math.min(grouped[bucketTime].low, +d.Low);
//         grouped[bucketTime].close = +d.Close;
//       }
//     });
//     return Object.values(grouped).sort((a, b) => a.time - b.time);
//   }, []);

//   const handleTimeframeChange = useCallback(
//     debounce((tf) => {
//       setTimeframe(tf);
//     }, 300),
//     []
//   );

//   useEffect(() => {
//     const socket = io(SOCKET, {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 2000,
//     });
//     socketRef.current = socket;
//     socket.on("connect", () => console.log("Socket connected:", socket.id));
//     socket.on("disconnect", () => console.log("Socket disconnected"));
//     return () => socket.disconnect();
//   }, [SOCKET]);

//   useEffect(() => {
//     const socket = socketRef.current;
//     if (!socket || !priceHistory || priceHistory.length === 0) return;

//     const listeners = priceHistory.map((item) => {
//       const handler = (data) => {
//         if (!data || data.length === 0) return;
//         if (item.id === companyId) {
//           fullDataRef.current = data;
//           const filteredData = filterDataByTimeframe(data, timeframe);
//           const intervalMinutes = timeframeMap[timeframe];
//           let newCandleData;
//           if (intervalMinutes) {
//             newCandleData = aggregateData(filteredData, intervalMinutes);
//           } else {
//             const uniqueMap = new Map();
//             filteredData.forEach((d) => {
//               const t = Math.floor(new Date(+d.Date) / 1000);
//               uniqueMap.set(t, {
//                 time: t,
//                 open: +d.Open,
//                 high: +d.High,
//                 low: +d.Low,
//                 close: +d.Close,
//               });
//             });
//             newCandleData = Array.from(uniqueMap.values()).sort(
//               (a, b) => a.time - b.time
//             );
//           }
//           setCandleData(newCandleData);
//           const lastCandle = data.at(-1);
//           if (lastCandle) {
//             setLatestAmount(lastCandle.Close);
//             setLatestData((prev) => ({
//               ...prev,
//               [companyId]: lastCandle.Close,
//             }));
//           }
//         }
//         const lastCandle = data.at(-1);
//         const lastBaseCandle = data.at(-2);
//         if (lastCandle && lastBaseCandle) {
//           setLatestCloses((prev) => ({ ...prev, [item.id]: lastCandle.Close }));
//           setLatestBaseCloses((prev) => ({
//             ...prev,
//             [item.id]: lastBaseCandle.Close,
//           }));
//         }
//       };
//       socket.on(item.id, handler);
//       return { id: item.id, handler };
//     });

//     return () =>
//       listeners.forEach(({ id, handler }) => socket.off(id, handler));
//   }, [
//     companyId,
//     priceHistory,
//     timeframe,
//     filterDataByTimeframe,
//     aggregateData,
//     timeframeMap,
//     setLatestAmount,
//     setLatestData,
//     setLatestCloses,
//     setLatestBaseCloses,
//   ]);

//   return (
//     <>
//       <section className="Main_Chart_Section">
//         {hoveredCandle && (
//           <div
//             style={{ color: "#fff", marginBottom: "10px", fontSize: "14px" }}
//           >
//             <strong>{hoveredCandle.date?.toLocaleString()}</strong>
//             <br />
//             Open: {hoveredCandle.open} | High: {hoveredCandle.high} | Low:{" "}
//             {hoveredCandle.low} | Close: {hoveredCandle.close}
//           </div>
//         )}
//         <div
//           className="timeframe_buttons_holder"
//           style={{ marginBottom: "10px", textAlign: "right" }}
//         >
//           <p className="company_name">{companyName}</p>
//           <div>
//             {["1M", "2M", "5M", "15M", "30M", "1H", "2H", "3H", "4H", "1Y"].map(
//               (tf) => (
//                 <button
//                   key={tf}
//                   onClick={() => handleTimeframeChange(tf)}
//                   className="timeframe_buttons"
//                   style={{
//                     backgroundColor: timeframe === tf ? "#007bff" : "#333",
//                   }}
//                 >
//                   {tf}
//                 </button>
//               )
//             )}
//           </div>
//         </div>
//         {priceHistory.map(
//           (value) =>
//             value.id === companyId && (
//               <div className="candle_chart_div" key={value.id}>
//                 <Suspense fallback={<div>Loading chart...</div>}>
//                   {candleData.length > 0 && (
//                     <StockAdvancedChart
//                       companyId={value.id}
//                       timeframe={timeframe}
//                       candleData={candleData}
//                       setLatestAmount={setLatestAmount}
//                     />
//                   )}
//                 </Suspense>
//               </div>
//             )
//         )}
//         <div className="profit_div">
//           <p
//             className="status_text loss_text"
//             onClick={() => setShowPortfoliofOffCanva(true)}
//           >
//             portfolio
//             <FontAwesomeIcon icon={faAngleUp} className="icon" />
//           </p>
//         </div>
//         <div className="byu_sell_div">
//           <Buy_sell_Btns
//             latestAmount={latestAmount}
//             setPrice={setPrice}
//             price={price}
//             sellOnClick={() => setShowmarketfOffCanva(true)}
//             BuyOnClick={() => setShowmarketfOffCanva(true)}
//           />
//         </div>
//         <Offcanvas
//           className="col_4_offcanvas col_2_offcanvas"
//           show={showmarketfOffCanva}
//           onHide={() => setShowmarketfOffCanva(false)}
//           placement="end"
//         >
//           <Offcanvas.Body>
//             <Right_End_Toolbar
//               setPrice={setPrice}
//               price={price}
//               latestAmount={latestAmount}
//               companyId={companyId}
//               companyName={companyName}
//               onClose={() => setShowmarketfOffCanva(false)}
//               openSuccess={() => setShowModal(true)}
//               openSuccessClose={() => setShowModal(false)}
//               isMobile={true}
//             />
//           </Offcanvas.Body>
//         </Offcanvas>
//         <Offcanvas
//           className="col_4_offcanvas portfolio_mobile_offcanvas"
//           show={showPortfoliofOffCanva}
//           onHide={() => setShowPortfoliofOffCanva(false)}
//           placement="bottom"
//         >
//           <Offcanvas.Header>
//             <FontAwesomeIcon
//               icon={faAngleDown}
//               className="down_icon"
//               onClick={() => setShowPortfoliofOffCanva(false)}
//             />
//           </Offcanvas.Header>
//           <Offcanvas.Body>
//             <div className="main_div">
//               <Portfolio
//                 getGraphData={getGraphData}
//                 onHide={onHide}
//                 companyId={companyId}
//                 belowGraphData={belowGraphData}
//                 latestAmount={latestAmount}
//                 setActiveBtn={setActiveBtn}
//                 activeBtn={activeBtn}
//                 handlePageChange={handlePageChange}
//                 showClsoeModal={showClsoeModal}
//                 showDeleteModal={showDeleteModal}
//                 showClsoeModalClose={showClsoeModalClose}
//                 showDeleteModalClose={showDeleteModalClose}
//                 setCloseTradeId={setCloseTradeId}
//                 closeTradeId={closeTradeId}
//               />
//             </div>
//           </Offcanvas.Body>
//         </Offcanvas>
//         <Successfull_Modal
//           message="Trade Successful!"
//           show={showModal}
//           onHide={() => setShowModal(false)}
//           lottie={<Deposit_Lottie />}
//         />
//       </section>
//     </>
//   );
// };

// export default Main_Chart_Section;

// 16 10 2025
// ----------------------------------------------------------------------------------------------------------
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
  useContext,
  Suspense,
} from "react";
import "./Main_Chart_Section.css";
import { Offcanvas } from "react-bootstrap";
import io from "socket.io-client";
import Buy_sell_Btns from "../right_end_toolbar/buy_sell_btns/Buy_sell_Btns";
import Right_End_Toolbar from "../right_end_toolbar/Right_End_Toolbar";
import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Portfolio from "./portfolio/Portfolio";
import { Context } from "../../../../utils/context";
import TradingViewChart from "./TradingViewChart";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

const StockAdvancedChart = React.lazy(() => import("./StockAdvancedChart"));

const Main_Chart_Section = ({
  companyId,
  setLatestAmount,
  latestAmount,
  price,
  setPrice,
  companyName,
  setLatestData,
  latestData,
  priceHistory,
  setPriceHistory,
  latestCloses,
  setLatestCloses,
  latestBaseCloses,
  setLatestBaseCloses,
  getGraphData,
  onHide,
  belowGraphData,
  setActiveBtn,
  activeBtn,
  handlePageChange,
  showClsoeModal,
  showDeleteModal,
  showClsoeModalClose,
  showDeleteModalClose,
  setCloseTradeId,
  closeTradeId,
}) => {
  const { SOCKET } = useContext(Context);
  const [showmarketfOffCanva, setShowmarketfOffCanva] = useState(false);
  const [showPortfoliofOffCanva, setShowPortfoliofOffCanva] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hoveredCandle, setHoveredCandle] = useState(null);
  const [timeframe, setTimeframe] = useState("1M");
  const [candleData, setCandleData] = useState([]);
  const [twentyFourHigh, setTwentyFourHigh] = useState(null);
  const [twentyFourLow, setTwentyFourLow] = useState(null);

  const fullDataRef = useRef([]);
  const socketRef = useRef(null);

  const timeframeMap = useMemo(
    () => ({
      "1M": 1,
      "2M": 2,
      "5M": 5,
      "15M": 15,
      "30M": 30,
      "1H": 60,
      "2H": 120,
      "3H": 180,
      "4H": 240,
      "1D": 240 * 6,
      "1M ": 43200,
      // "1Y": 525600,
      ALL: null,
    }),
    []
  );

  const filterDataByTimeframe = useCallback((data, tf) => {
    if (!data || data.length === 0) return [];
    const now = new Date();
    let cutoff = new Date();
    switch (tf) {
      case "1M":
        cutoff.setMinutes(now.getMinutes() - 60);
        break;
      case "2M":
        cutoff.setMinutes(now.getMinutes() - 120);
        break;
      case "5M":
        cutoff.setMinutes(now.getMinutes() - 300);
        break;
      case "15M":
        cutoff.setMinutes(now.getMinutes() - 900);
        break;
      case "30M":
        cutoff.setMinutes(now.getMinutes() - 1800);
        break;
      case "1H":
        cutoff.setHours(now.getHours() - 1);
        break;
      case "2H":
        cutoff.setHours(now.getHours() - 2);
        break;
      case "3H":
        cutoff.setHours(now.getHours() - 3);
        break;
      case "4H":
        cutoff.setHours(now.getHours() - 4);
        break;
      case "1D":
        cutoff.setHours(now.getHours() - 24);
        break;
      case "1M ":
        cutoff.setMonth(now.getMonth() - 1);

        break;
      case "ALL":
      default:
        return data;
    }
    return data;
  }, []);

  // ✅ Aggregate including Volume
  const aggregateData = useCallback((data, intervalMinutes) => {
    const grouped = {};
    data.forEach((d) => {
      const bucketTime =
        Math.floor(+d.Date / (1000 * 60 * intervalMinutes)) *
        (60 * intervalMinutes);
      if (!grouped[bucketTime]) {
        grouped[bucketTime] = {
          time: bucketTime,
          open: +d.Open,
          high: +d.High,
          low: +d.Low,
          close: +d.Close,
          volume: +d.Volume || 0,
        };
      } else {
        grouped[bucketTime].high = Math.max(grouped[bucketTime].high, +d.High);
        grouped[bucketTime].low = Math.min(grouped[bucketTime].low, +d.Low);
        grouped[bucketTime].close = +d.Close;
        grouped[bucketTime].volume += +d.Volume || 0;
      }
    });
    return Object.values(grouped).sort((a, b) => a.time - b.time);
  }, []);

  const handleTimeframeChange = useCallback(
    debounce((tf) => {
      setTimeframe(tf);
    }, 300),
    []
  );

  // ✅ Socket connection
  useEffect(() => {
    const socket = io(SOCKET, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });
    socketRef.current = socket;
    socket.on("connect", () => console.log("Socket connected:", socket.id));
    socket.on("disconnect", () => console.log("Socket disconnected"));
    return () => socket.disconnect();
  }, [SOCKET]);

  // ✅ Handle incoming data
  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !priceHistory || priceHistory.length === 0) return;

    const listeners = priceHistory.map((item) => {
      const handler = (data) => {
        if (!data || data.length === 0) return;

        if (item.id === companyId) {
          fullDataRef.current = data;

          const filteredData = filterDataByTimeframe(data, timeframe);
          const intervalMinutes = timeframeMap[timeframe];
          let newCandleData;

          if (intervalMinutes) {
            newCandleData = aggregateData(filteredData, intervalMinutes);
          } else {
            const uniqueMap = new Map();
            filteredData.forEach((d) => {
              const t = Math.floor(new Date(+d.Date) / 1000);
              uniqueMap.set(t, {
                time: t,
                open: +d.Open,
                high: +d.High,
                low: +d.Low,
                close: +d.Close,
                volume: +d.Volume || 0,
              });
            });
            newCandleData = Array.from(uniqueMap.values()).sort(
              (a, b) => a.time - b.time
            );
          }

          setCandleData(newCandleData);

          // ✅ Update latest price
          const lastCandle = data.at(-1);
          if (lastCandle) {
            setLatestAmount(lastCandle.Close);
            setLatestData((prev) => ({
              ...prev,
              [companyId]: lastCandle.Close,
            }));
          }

          // ✅ Calculate 24H High/Low
          const last24hData = data.filter(
            (d) => new Date() - new Date(+d.Date) <= 24 * 60 * 60 * 1000
          );
          if (last24hData.length) {
            const high24h = Math.max(...last24hData.map((d) => +d.High));
            const low24h = Math.min(...last24hData.map((d) => +d.Low));
            setTwentyFourHigh(high24h);
            setTwentyFourLow(low24h);
          }
        }

        // ✅ Update last closes
        const lastCandle = data.at(-1);
        const lastBaseCandle = data.at(-2);
        if (lastCandle && lastBaseCandle) {
          setLatestCloses((prev) => ({ ...prev, [item.id]: lastCandle.Close }));
          setLatestBaseCloses((prev) => ({
            ...prev,
            [item.id]: lastBaseCandle.Close,
          }));
        }
      };

      socket.on(item.id, handler);
      return { id: item.id, handler };
    });

    return () =>
      listeners.forEach(({ id, handler }) => socket.off(id, handler));
  }, [
    companyId,
    priceHistory,
    timeframe,
    filterDataByTimeframe,
    aggregateData,
    timeframeMap,
    setLatestAmount,
    setLatestData,
    setLatestCloses,
    setLatestBaseCloses,
  ]);

  // ✅ UI Rendering
  return (
    <>
      <section className="Main_Chart_Section">
        {/* Hovered Candle Tooltip */}
        {hoveredCandle && (
          <div
            style={{ color: "#fff", marginBottom: "10px", fontSize: "14px" }}
          >
            <strong>{hoveredCandle.date?.toLocaleString()}</strong>
            <br />
            Open: {hoveredCandle.open} | High: {hoveredCandle.high} | Low:{" "}
            {hoveredCandle.low} | Close: {hoveredCandle.close}
          </div>
        )}

        <div
          className="twentyfour-stats"
          style={{
            color: "#ccc",
            fontSize: "14px",
            textAlign: "right",
            marginBottom: "10px",
          }}
        >
          <strong>24h High:</strong> {twentyFourHigh ?? "-"} &nbsp; | &nbsp;
          <strong>24h Low:</strong> {twentyFourLow ?? "-"}
        </div>

        {/* Timeframe buttons */}
        <div
          className="timeframe_buttons_holder"
          style={{ marginBottom: "10px", textAlign: "right" }}
        >
          <p className="company_name">{companyName}</p>
          <div>
            {[
              "1M",
              "2M",
              "5M",
              "15M",
              "30M",
              "1H",
              "2H",
              "4H",
              "1D",
              "1M ",
            ].map((tf) => (
              <button
                key={tf}
                onClick={() => handleTimeframeChange(tf)}
                className="timeframe_buttons"
                style={{
                  backgroundColor: timeframe === tf ? "#007bff" : "#333",
                }}
              >
                {tf}
              </button>
            ))}
          </div>
        </div>

        {/* Chart Section */}
        {priceHistory.map(
          (value) =>
            value.id === companyId && (
              <div className="candle_chart_div" key={value.id}>
                <Suspense fallback={<div>Loading chart...</div>}>
                  {candleData.length > 0 && (
                    <>
                      <StockAdvancedChart
                        companyId={value.id}
                        timeframe={timeframe}
                        candleData={candleData}
                        setLatestAmount={setLatestAmount}
                        showVolume={true}
                      />
                    </>
                  )}
                </Suspense>
              </div>
            )
        )}

        {/* Portfolio and Buy/Sell Buttons */}
        <div className="profit_div">
          <p
            className="status_text loss_text"
            onClick={() => setShowPortfoliofOffCanva(true)}
          >
            portfolio
            <FontAwesomeIcon icon={faAngleUp} className="icon" />
          </p>
        </div>

        <div className="byu_sell_div">
          <Buy_sell_Btns
            latestAmount={latestAmount}
            setPrice={setPrice}
            price={price}
            sellOnClick={() => setShowmarketfOffCanva(true)}
            BuyOnClick={() => setShowmarketfOffCanva(true)}
          />
        </div>

        {/* Right Toolbar Offcanvas */}
        <Offcanvas
          className="col_4_offcanvas col_2_offcanvas"
          show={showmarketfOffCanva}
          onHide={() => setShowmarketfOffCanva(false)}
          placement="end"
        >
          <Offcanvas.Body>
            <Right_End_Toolbar
              setPrice={setPrice}
              price={price}
              latestAmount={latestAmount}
              companyId={companyId}
              companyName={companyName}
              onClose={() => setShowmarketfOffCanva(false)}
              openSuccess={() => setShowModal(true)}
              openSuccessClose={() => setShowModal(false)}
              isMobile={true}
            />
          </Offcanvas.Body>
        </Offcanvas>

        {/* Portfolio Offcanvas */}
        <Offcanvas
          className="col_4_offcanvas portfolio_mobile_offcanvas"
          show={showPortfoliofOffCanva}
          onHide={() => setShowPortfoliofOffCanva(false)}
          placement="bottom"
        >
          <Offcanvas.Header>
            <FontAwesomeIcon
              icon={faAngleDown}
              className="down_icon"
              onClick={() => setShowPortfoliofOffCanva(false)}
            />
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="main_div">
              <Portfolio
                getGraphData={getGraphData}
                onHide={onHide}
                companyId={companyId}
                belowGraphData={belowGraphData}
                latestAmount={latestAmount}
                setActiveBtn={setActiveBtn}
                activeBtn={activeBtn}
                handlePageChange={handlePageChange}
                showClsoeModal={showClsoeModal}
                showDeleteModal={showDeleteModal}
                showClsoeModalClose={showClsoeModalClose}
                showDeleteModalClose={showDeleteModalClose}
                setCloseTradeId={setCloseTradeId}
                closeTradeId={closeTradeId}
              />
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Success Modal */}
        <Successfull_Modal
          message="Trade Successful!"
          show={showModal}
          onHide={() => setShowModal(false)}
          lottie={<Deposit_Lottie />}
        />
      </section>
    </>
  );
};

export default Main_Chart_Section;
